import { CallCardLabels } from './PatientAccessCallTimelineItem';

/**
 * The card title. Middot, matching the `PN ·` / `PT ·` convention across Orbit.
 *
 * "Inbound" is gone from the name deliberately: every call this card runs is
 * inbound, so the word was carrying the distinction from a scheduled card that
 * no longer exists.
 */
export const PAC_INTRO_CALL_CARD_TITLE = 'PAC · Intro call';

/**
 * The same card in the chart-note picker, where the house style is a hyphen —
 * `PN - Consultation`, `PN - Warm handoff card`. The middot is the timeline's.
 */
export const PAC_INTRO_CALL_PICKER_LABEL = 'PAC - Intro call';

export const PAC_INTRO_CALL_LABELS: CallCardLabels = {
  start: 'Start intro call notes',
  show: 'Show intro call notes',
  hide: 'Hide intro call notes',
};
